<template>
  <v-card>
    <v-card-text>
      <h3>Area</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'acre',
          val: 1
        },
        {
          text: 'are (a)',
          val: 40.468564224
        },
        {
          text: 'barn (b)',
          val: 4.0468564224e31
        },
        {
          text: 'hectare (ha)',
          val: 0.40468564224
        },
        {
          text: 'homestead',
          val: 0.00625
        },
        {
          text: 'rood',
          val: 4
        },
        {
          text: 'square centimeter (cm²)',
          val: 40468564.224
        },
        {
          text: 'square foot (ft²)',
          val: 43560
        },
        {
          text: 'square inch (in²)',
          val: 6272640
        },
        {
          text: 'square kilometer (km²)',
          val: 0.0040468564224
        },
        {
          text: 'square meter (m²)',
          val: 4046.8564224
        },
        {
          text: 'square mile',
          val: 0.0015625
        },
        {
          text: 'square millimeter (mm²)',
          val: 4046856422.4
        },
        {
          text: 'square rod',
          val: 160
        },
        {
          text: 'square yard (yd²)',
          val: 4840
        },
        {
          text: 'township (twp)',
          val: 0.00004340277777778
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// area.vue?40197eb5